import React from "react"
import { useLocale } from "src/common/hooks"
import { BLOCKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import get from "lodash/get"

import { getModalClickHandler } from "src/components/ModalsContainer/events"
import { Indent, Title } from "src/uikit"
import Button from "src/newUikit/Button"

import Case from "./components/Case"
import * as S from "./styled"

const options = {
  renderNode: {
    // eslint-disable-next-line react/display-name
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const locale = useLocale()

      const { fields } = node.data.target
      const title = get(fields, `heading.${locale}`, null)
      const description = get(fields, `description.${locale}`, null)
      const link = get(fields, `useCaseURL.${locale}`, null)
      const btnName = get(fields, `linkName.${locale}`, null)
      const modalType = get(fields, `modalType.${locale}`, null)
      const modalTitle = get(fields, `modalTitle.${locale}`, null)

      return (
        <Case
          title={title}
          json={description}
          btnName={btnName}
          url={link}
          modalType={modalType}
          modalTitle={modalTitle}
        />
      )
    },
  },
}

const UseCases = ({
  title,
  json,
  ctaBtnName,
  ctaBtnUrl,
  ctaBtnModalType,
  ctaBtnModalTitle,
}) => {
  const handleCtaClick = getModalClickHandler(ctaBtnModalType, {
    title: ctaBtnModalTitle,
  })

  return (
    <S.Container>
      <div className="inner">
        <Indent lg={160} md={180} sm={180} />
        <Title>{title}</Title>
        <Indent lg={40} md={32} sm={32} />
        <div className="cases">{documentToReactComponents(json, options)}</div>
        <Indent lg={64} md={0} sm={0} />
        <div className="cta-container">
          {ctaBtnUrl && (
            <Button url={ctaBtnUrl} size="large" inverse color="purple">
              {ctaBtnName}
            </Button>
          )}
          {ctaBtnModalType && (
            <Button
              size="large"
              inverse
              color="purple"
              onClick={handleCtaClick}
            >
              {ctaBtnName}
            </Button>
          )}
        </div>
      </div>
    </S.Container>
  )
}

export default UseCases
